import useFetch from "../../hooks/useFetch";

/**
 * Fetch tasks for the current mentor.
 * @param {Object} options - useFetch options (onSuccess, onError, enabled, etc.)
 * isAcknowledged: 0 = pending, 1 = acknowledged
 */
export const useFetchTasks = (isAcknowledged = 0, options = {}) => {
  return useFetch("/task", {
    method: "get",
    params: { isAcknowledged },
    ...options,
  });
};

/**
 * Shorthand for pending tasks (isAcknowledged = 0).
 */
export const useFetchPendingTasks = (options = {}) => {
  return useFetchTasks(0, options);
};

/**
 * Shorthand for acknowledged tasks (isAcknowledged = 1).
 */
export const useFetchAcknowledgedTasks = (options = {}) => {
  return useFetchTasks(1, options);
};

/**
 * Acknowledge a task by taskId (manual: true — call mutate({ url }) to fire).
 */
export const useAcknowledgeTask = (options = {}) => {
  return useFetch("/task/acknowledge", {
    method: "put",
    manual: true,
    ...options,
  });
};
